import * as React from 'react';
import * as d3 from 'd3';

export interface Props {
  currency: boolean;
  monthByMonth: any;
}

class MiniGraph extends React.PureComponent<Props> {
  GRAPH_WIDTH: number = 50;
  GRAPH_HEIGHT: number = 15;

  renderSVG() {
    const {monthByMonth, currency} = this.props;

    const monthByMonthValues: number[] = monthByMonth.map((data) => (
      currency ? data.revenue : data.traffic
    ));

    const max = Math.max(...monthByMonthValues);
    const min = Math.min(...monthByMonthValues);
    const dataPoints = monthByMonthValues.length;

    const scaleX = d3.scaleLinear()
      .domain([min, max])
      .range([1, this.GRAPH_HEIGHT - 1]);

    const scaleY = d3.scaleLinear()
      .domain([0, dataPoints])
      .range([0, this.GRAPH_WIDTH]);

    const normalizedData = monthByMonthValues.map((data, i) => ({
      x: scaleY(i),
      y: scaleX(data),
    }));

    const lineFunction = d3.line()
      .x((data) => data.x)
      .y((data) => this.GRAPH_HEIGHT - data.y);

    return (
      <svg
        width={this.GRAPH_WIDTH}
        height={this.GRAPH_HEIGHT}
        viewBox={`0 0 ${this.GRAPH_WIDTH} ${this.GRAPH_HEIGHT}`}
        perserve-aspect-ratio="xMinYMid"
      >

        <linearGradient id="gradient">
          <stop offset="5%" stopColor="#e3ccef" />
          <stop offset="95%" stopColor="#432056" />
        </linearGradient>

        <path d={lineFunction(normalizedData)} stroke="url(#gradient)" fill="none" strokeWidth="1.5" />
      </svg>
    );
  }

  render() {
    const {monthByMonth} = this.props;

    if (!monthByMonth) {
      return null;
    }

    return this.renderSVG();
  }
}

export default MiniGraph;
